export const en = {
    Navigation: {
        me: {
            label: "Me",
            description: "Your profile"
        }
    },
    AuthenticatedLayout: {
        title: "Workleap",
        agent: "Agent",
        jumpTo: "Jump to",
        openNavigation: "Open navigation",
        closeNavigation: "Close navigation",
        primaryNavigation: "Primary",
        openUserMenu: "Open workspace and user menu",
        accountSettings: "Personal settings",
        organizationSettings: "Organization settings",
        workspace: "Workspace",
        currentWorkspace: "Current workspace",
        switchWorkspaceError: "Couldn't switch workspace. Please try again.",
        loadingWorkspaces: "Loading workspaces",
        switchingWorkspace: "Switching workspace",
        logout: "Log out",
        helpCenter: "Help center",
        helpCenterUrl: "https://help.workleap.com/en/collections/19772749-the-new-workleap",
        opensInNewTab: "opens in a new tab",
        takeTheTour: "Take the tour",
        resizeAgentPanel: "Resize agent panel",
        skipToMainContent: "Skip to main content"
    },
    AssistantTabIndicator: {
        working: "Working…",
        done: "Done",
        error: "Error"
    },
    CreateMenu: {
        create: "Create",
        newSurvey: "New survey",
        newReviewCycle: "New review cycle",
        newPlan: "New plan"
    },
    SidebarLayout: {
        navigation: "Sections",
        closeMenu: "Close menu",
        collapseNavigation: "Collapse navigation",
        expandNavigation: "Expand navigation"
    },
    TabsLayout: {
        tabs: "Tabs",
        externalTab: {
            title: "You're leaving Workleap",
            body: "{{appName}} opens in a new tab.",
            cancel: "Cancel",
            continue: "Continue",
            newTab: "(opens in a new tab)"
        }
    },
    SectionMenuTrigger: {
        openMenu: "{{title}}, open menu"
    },
    ModuleErrorBoundary: {
        title: "Something went wrong",
        description: "We couldn't load this page. You can try again, or head back home.",
        retry: "Try again",
        goHome: "Go home"
    },
    NotFoundPage: {
        title: "Page not found",
        code: "404",
        description: "This page could not be found.",
        backHome: "Back to home"
    },
    OrganizationAccessPage: {
        title: "Not available",
        heading: "Not available for your organization yet",
        body: "Your organization doesn't have access to the new Workleap experience. You can keep using the classic Workleap experience.",
        backToWorkleap: "Back to Workleap"
    },
    RootErrorBoundary: {
        title: "Something went wrong",
        description: "The application could not start. Try refreshing the page or returning to the home page.",
        goHome: "Go home"
    },
    BootstrappingRoute: {
        loading: "Loading"
    },
    unmanagedMutationErrors: {
        toastMessage: "Something went wrong. Please try again."
    },
    CommandMenu: {
        placeholder: "Jump to",
        noResults: "No results match your search.",
        searching: "Searching...",
        dialogLabel: "Command palette",
        searchLabel: "Quick search",
        sections: {
            people: "People",
            teams: "Teams"
        },
        memberCount_one: "{{count}} member",
        memberCount_other: "{{count}} members",
        footer: {
            navigate: "navigate",
            open: "open",
            escToClose: "esc to close"
        }
    },
    ProductTour: {
        stepCounter: "{{current}} of {{total}}",
        skip: "Skip tour",
        back: "Back",
        next: "Next",
        done: "Done",
        stepAnnouncement: "Step {{current}} of {{total}}: {{title}}"
    },
    OnboardingProductTour: {
        agent: {
            title: "Your AI agent, on every page",
            body: "Your agent uses engagement results, goals, Good Vibes, and your connected tools to prepare meeting agendas, draft feedback replies, and write performance reviews, ready for you to edit."
        },
        navigation: {
            title: "Everything you need, within reach",
            bodyIndividual: "Your Good Vibes, goals, reviews, and more, plus everything that applies to the whole organization.",
            bodyTeam: "Engagement, goals, Good Vibes, performance reviews, meetings, and more, from the angle you need."
        },
        shortcuts: {
            title: "Jump straight to it",
            body: "Find any person or page from wherever you are. Use + to create Good Vibes, feedback, goals, and more."
        },
        analytics: {
            title: "Help every team thrive",
            body: "Compare how teams are doing to see where your support will make the biggest difference."
        },
        restart: {
            title: "Help is always close",
            body: "Open your profile menu anytime to replay this tour or visit the help center."
        }
    }
};
